(function(angular){
	'use strict';
	
	var historicalDividendsOnInvestmentChartObject = {
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		bindings: {
			reitName: '@'
		},
		controller: [
			'$filter',
			'urlFactory',
			HistoricalDividendsOnInvestmentChartFunction
		],
		controllerAs: 'historicalDividendsOnInvestmentChart'
	};
	
	angular
		.module('productPage')
		.component('historicalDividendsOnInvestmentChart', historicalDividendsOnInvestmentChartObject);
	
	function templateUrlFunction(STATIC_BASE_PATH) {
		return STATIC_BASE_PATH + '/static/html/reits/product-pages/historical-dividends-on-investment-chart.html';
	}
	
	function HistoricalDividendsOnInvestmentChartFunction(
		$filter,
		urlFactory){
		var historicalDividendsOnInvestmentChart = this;

		historicalDividendsOnInvestmentChart.$onInit = function() {
			urlFactory.getPromise('/hypothetical-investments.json?reitOfferingUrlSlug=' + historicalDividendsOnInvestmentChart.reitName)
				.then(
					function(response) {
						initChart(response.data[2].dividends);
					}
				);
		};

		function initChart(responseData){
			var data = [];
			var xAxisLabels = [];

			angular.forEach(responseData, function(entry) {

				var chartDataPoint = {
					name: 'Q' + entry.quarter.quarter + ' ' + entry.quarter.year,
					y: entry.amount
				};

				data.push(chartDataPoint);
			});

			historicalDividendsOnInvestmentChart.chartOptions = {
				chart: {
					type: 'column'
				},
				series: [{
					data: data,
					states: {
						hover: {
							enabled: true
						}
					}
				}],
				tooltip: {
					enabled: true,
					formatter: function() {
						return '<span class="eta display-block body-text-color text-align-center">' + this.point.name + '</span><span class="zeta display-block heading-text-color font-weight-bold text-align-center">' + $filter('currency')(this.y, '$', 2) + '</span>';
					}
				},
				xAxis: {
					type: 'category'
				},
				yAxis: {
					labels: {
						formatter: function() {
							return $filter('currency')(this.value, '$', 0);
						}
					}
				}
			};
		}
	}
})(window.angular);